import { FISH_BY_KEY, FRONT_ITEMS, ITEM_BY_KEY, OVER_GEM_ITEMS, pixoAsset } from "@/lib/pixo";
import "./pixo.css";
import "./fishing.css";

// Sparkle positions (sprite pixels) for the celebrate pose.
const SPARKS = [[3, 6], [32, 4], [1, 18], [35, 16], [8, 0], [27, 0], [17, -2]];
const BODY = { idle: "happy", celebrate: "joy", yawn: "yawn", drop: "sleep", sleep: "lying" };

/**
 * Layered pixel Pixie. Layers (back to front): effect, back, body, eyes, pin, head, gem, hand.
 * pose: idle | celebrate | yawn | drop | sleep. Accessories come off while lying down.
 */
export default function PixoSprite({ gem, equipped = {}, pose = "idle", scale = 4, onClick, className = "", shadow = true, label, glow = false, showFish = null }) {
  const lying = pose === "sleep" || pose === "drop";
  const fish = !lying && showFish ? FISH_BY_KEY[showFish] : null; // holding a fish: armless body, no hand item
  const layer = (slot) => {
    const key = equipped?.[slot];
    if (!key || !ITEM_BY_KEY[key]) return null;
    if (lying) return null; // batch 21: nothing worn while lying down (the Holo Aura too)
    if (fish && slot === "hand") return null;
    return <img key={slot} src={pixoAsset.item(key)} alt="" draggable={false} className={key === "holo_aura" ? "pixo-aura" : undefined} />;
  };
  // the Deck Bag hangs in front of the body; the Pirate Hat sits over the gem (its tip pokes through the peak)
  const backFront = FRONT_ITEMS.has(equipped?.back);
  const headOver = OVER_GEM_ITEMS.has(equipped?.head);

  return (
    <div
      className={`pixo pixo-${pose} ${onClick ? "pixo-clickable" : ""} ${glow ? "pixo-glowing" : ""} ${className}`}
      style={{ "--s": scale }}
      onClick={onClick}
      role={onClick ? "button" : "img"}
      aria-label={label || "Pixie"}
      data-testid="pixo-sprite"
      data-pose={pose}
    >
      {shadow && !lying && <div className="pixo-shadow" />}
      <div className="pixo-stack">
        {layer("effect")}
        {!backFront && layer("back")}
        <img src={fish ? pixoAsset.body("show") : pixoAsset.body(BODY[pose] || "happy")} alt="" draggable={false} />
        {backFront && layer("back")}
        {layer("eyes")}
        {layer("pin")}
        {!headOver && layer("head")}
        <img className="pixo-gem" src={pixoAsset.gem(gem)} alt="" draggable={false} />
        {headOver && layer("head")}
        {layer("hand")}
        {fish && (
          <img
            className={`pixo-showfish ${showFish === "grail_fish" ? "fishing-chrome" : ""}`}
            src={pixoAsset.fish(showFish)}
            alt=""
            draggable={false}
            style={{ left: `calc(var(--s) * ${20 - fish.w / 2}px)`, top: `calc(var(--s) * ${32 - fish.h / 2}px)`, width: `calc(var(--s) * ${fish.w}px)`, height: `calc(var(--s) * ${fish.h}px)` }}
          />
        )}
      </div>
      {pose === "celebrate" &&
        SPARKS.map(([x, y], i) => (
          <img
            key={i}
            className="pixo-spark"
            src={pixoAsset.sparkle}
            alt=""
            style={{ left: `calc(var(--s) * ${x}px)`, top: `calc(var(--s) * ${y}px)`, animationDelay: `${(i % 3) * 0.1}s` }}
          />
        ))}
      {pose === "sleep" &&
        [0, 1, 2].map((i) => (
          <img
            key={i}
            className="pixo-z"
            src={pixoAsset.z}
            alt=""
            style={{ left: `calc(var(--s) * ${27 + i * 3}px)`, top: `calc(var(--s) * ${16 - i * 5}px)`, animationDelay: `${i * 0.8}s` }}
          />
        ))}
    </div>
  );
}
